import React, { useState, useMemo , useEffect} from 'react';
import { Card, Table, Tag, Avatar, Space, Empty, DatePicker } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { API_BASE_URL } from '../config';
const { RangePicker } = DatePicker;

const RankingList = ({ }) => {
  // 获取今年1月1日和当前日期作为默认值
  const currentYear = dayjs().year();
  const defaultStartDate = dayjs(`${currentYear}-01-01`);
  const defaultEndDate = dayjs();
  const [postcountsData, setPostcountsData] = useState([]);
  const [likecountsData, setLikecountsData] = useState([]);
  const [commentcountsData, setCommentcountsData] = useState([]);
  const [valueuser_likecountsData, setValueuser_likecountsData] = useState([]);


  // 初始化时获取今年数据
  useEffect(() => {
    // 使用现有的handleDateRangeChange函数，传入默认的日期范围
    handleDateRangeChange([defaultStartDate, defaultEndDate]);
    console.log("使用今年的日期");
  }, []);
  
  // 对数据进行排序并添加排名的通用函数
  const getRankedData = (data) => {
    const sortedData = [...(data || [])].sort((a, b) => b.count - a.count);
    return sortedData.map((item, index) => ({
      ...item,
      rank: index + 1,
      key: item.vp_du_id || item.vl_du_id || item.vc_du_id || index
    }));
  };
  
  const valueuserRankedData = useMemo(() => getRankedData(valueuser_likecountsData), [valueuser_likecountsData]);
  const postRankedData = useMemo(() => getRankedData(postcountsData), [postcountsData]);
  const likeRankedData = useMemo(() => getRankedData(likecountsData), [likecountsData]);
  const commentRankedData = useMemo(() => getRankedData(commentcountsData), [commentcountsData]);
  
  const columns = [
    {
      title: '排名',
      dataIndex: 'rank',
      key: 'rank',
      width: 80,
      render: (rank) => {
        let color = 'default';
        let icon = <span>{rank}</span>;
        
        if (rank === 1) {
          color = 'gold';
          icon = <TrophyOutlined style={{ color: '#f5a623' }} />;
        } else if (rank === 2) {
          color = 'default';
          icon = <TrophyOutlined style={{ color: '#c0c0c0' }} />;
        } else if (rank === 3) {
          color = 'default';
          icon = <TrophyOutlined style={{ color: '#cd7f32' }} />;
        }
        
        return (
          <Tag color={color} icon={icon} style={{ fontSize: '14px', width: '30px', textAlign: 'center' }}>
          </Tag>
        );
      }
    },
    {
      title: '用户',
      key: 'user',
      render: (record) => {
        const name = record.du_name;
        const avatar = record.du_avatar;
        return (
          <Space>
            <Avatar src={avatar} alt={name} />
            <span>{name}</span>
          </Space>
        );
      }
    },
    {
      title: '数量',
      dataIndex: 'count',
      key: 'count',
      sorter: (a, b) => b.count - a.count,
    },
  ];
  

  
  // 处理日期范围变化
  const handleDateRangeChange = async (dates, dateStrings) => {
    if (dates && dates[0] && dates[1]) {
      try {
        // 格式化日期为 YYYY-MM-DD HH:mm:ss
        const startDate = dates[0].format('YYYY-MM-DD HH:mm:ss');
        const endDate = dates[1].add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const response = await fetch(`${API_BASE_URL}/ranking/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          startDate: startDate,
          endDate: endDate
        })
      });
      const data = await response.json();
      if(data.success){
        console.log("排行榜总数据：",data);
        setPostcountsData(data.postcounts);
        setLikecountsData(data.likecounts);
        setCommentcountsData(data.commentcounts);
        setValueuser_likecountsData(data.valueuser_likecounts);
      }
      } catch (error) {
        console.error('发送时间范围到后端失败:', error);
      }
    }
  };
  
  // 检查是否所有排行榜都没有数据
  const hasNoData = valueuserRankedData.length === 0 && postRankedData.length === 0 && 
                   likeRankedData.length === 0 && commentRankedData.length === 0;
                   
  if (hasNoData) {
    return (
      <Card title="Value之星排行榜" bordered={true}>
        <Space direction="vertical" size={12} style={{ width: '100%', marginBottom: 16 }}>
          <Space>
            <span>选择时间范围：</span>
            <RangePicker 
              onChange={handleDateRangeChange}
              placeholder={['开始日期', '结束日期']}
              defaultValue={[defaultStartDate, defaultEndDate]}
            />
          </Space>
        </Space>
        
        <div style={{ textAlign: 'center', padding: '50px 0' }}>
          <Empty description="暂无数据，快去发布内容获得点赞吧！" />
        </div>
      </Card>
    );
  }
  
  // 创建单个排行榜表格组件
  const RankingTable = ({ data, title }) => {
    const tableColumns = [
      {
        title: '排名',
        dataIndex: 'rank',
        key: 'rank',
        width: 60,
        render: (rank) => {
          let color = 'default';
          let icon = <span>{rank}</span>;
          
          if (rank === 1) {
            color = 'gold';
            icon = <TrophyOutlined style={{ color: '#f5a623' }} />;
          } else if (rank === 2) {
            color = 'default';
            icon = <TrophyOutlined style={{ color: '#c0c0c0' }} />;
          } else if (rank === 3) {
            color = 'default';
            icon = <TrophyOutlined style={{ color: '#cd7f32' }} />;
          }
          
          return (
            <Tag color={color} icon={icon} style={{ fontSize: '12px', width: '25px', textAlign: 'center' }}>
            </Tag>
          );
        }
      },
      {
        title: '用户',
        key: 'user',
        render: (record) => {
          const name = record.du_name;
          const avatar = record.du_avatar;
          return (
            <Space size="small">
              <Avatar size="small" src={avatar} alt={name} />
              <span style={{ fontSize: '12px' }}>{name}</span>
            </Space>
          );
        }
      },
      {
        title: '数量',
        dataIndex: 'count',
        key: 'count',
        sorter: (a, b) => b.count - a.count,
      },
    ];
    
    return (
      <Card 
        title={title} 
        size="small" 
        style={{ flex: 1, minWidth: '300px', margin: '4px' }}
        bodyStyle={{ padding: '8px' }}
      >
        {data.length > 0 ? (
          <Table 
            columns={tableColumns}
            dataSource={data} 
            pagination={{ pageSize: 5, size: 'small' }}
            size="small"
            rowClassName={(record) => {
              if (record.rank === 1) return 'rank-first';
              if (record.rank === 2) return 'rank-second';
              if (record.rank === 3) return 'rank-third';
              return '';
            }}
            scroll={{ x: 'max-content' }}
          />
        ) : (
          <Empty description="暂无数据" style={{ padding: '20px 0' }} />
        )}
      </Card>
    );
  };
  
  return (
    <Card title="Value之星排行榜" bordered={true}>
      <Space direction="vertical" size={12} style={{ width: '100%', marginBottom: 16 }}>
        <Space>
          <span>选择时间范围：</span>
          <RangePicker 
            onChange={handleDateRangeChange}
            placeholder={['开始日期', '结束日期']}
            defaultValue={[defaultStartDate, defaultEndDate]}
          />
        </Space>
      </Space>
      
      {/* 响应式布局：大屏并排显示，小屏换行 */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '8px',
        justifyContent: 'flex-start'
      }}>
        <RankingTable data={valueuserRankedData} title="value之星排行榜 (value之星)" />
        <RankingTable data={postRankedData} title="发帖排行榜 (金手指)" />
        <RankingTable data={likeRankedData} title="点赞排行榜 (点赞王)" />
        <RankingTable data={commentRankedData} title="评论排行榜 (评论王)" />
      </div>
    </Card>
  );
};

export default RankingList;
